import { copyTextToClipboard } from '@kontentino/kontentino-utils/clipboard';
import i18n from 'app/utils/i18n';
import { showToast } from 'app/hooks/useToast';

export async function copyToClipboard(
  text: string,
  options?: { message?: string },
) {
  try {
    await copyTextToClipboard(text);
    showToast(options?.message ?? i18n.t('copiedToClipboard'), 'success');
  } catch (e) {
    showToast(i18n.t('somethingWentWrong'), 'error');
  }
}

export async function writeToClipboard(
  text: string | Promise<string>,
): Promise<boolean> {
  const pendingText = Promise.resolve(text);
  pendingText.catch(() => undefined);

  try {
    if (typeof ClipboardItem === 'function' && navigator.clipboard?.write) {
      const blob = pendingText.then(
        (value) => new Blob([value], { type: 'text/plain' }),
      );
      await navigator.clipboard.write([
        new ClipboardItem({ 'text/plain': blob }),
      ]);
      return true;
    }

    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(await pendingText);
      return true;
    }

    return false;
  } catch {
    return false;
  }
}

const useCopyToClipboard = () => copyToClipboard;

export default useCopyToClipboard;
